import {
    getInfo,
    login,
    logout,
    updatePassword,
    uploadAvatar,
    getScoreStatistic, forgotPassword, resetPassword
} from "@/api/auth";

import { getToken, removeToken } from "@/utils/auth";

const state = {
    //user data
    id: null,
    email: "",
    token: getToken(),
    name: "",
    avatar: "",
    roles: [],
    permissions: [],
    status: '',
    stripe_id: null,
    statistic: {
        instagram_comments_count: 0,
        instagram_like_count: 0,
        instagram_followers_count: 0,
        tiktok_views_count: 0,
        tiktok_likes_count: 0,
        tiktok_followers_count: 0,
    }
};

const getters = {
    userId: state => {
        return state.id;
    },

    stripeId: state => {
        return state.stripe_id;
    },
    
    status: state=> {
        return state.status;
    },

    userEmail: state => {
        return state.email;
    },

    userName: state => {
        return state.name;
    },

    userAvatar: state => {
        return state.avatar;
    },

    statistic: state => {
        return state.statistic
    }
};

const mutations = {
    dataReceivedSuccess: (state, response) => {
        state.id = response.id;
        state.email = response.email;
        state.name = response.name;
        state.roles = response.roles;
        state.avatar = response.avatar;
        state.permissions = response.permissions;
        state.stripe_id = response.stripe_id;
        state.status = response.status;
    },

    statisticReceivedSuccess: (state, response) => {
        state.statistic.instagram_comments_count = response.instagramCommentsCount;
        state.statistic.instagram_like_count = response.instagramLikeCount;
        state.statistic.instagram_followers_count = response.instagramFollowersCount;
        state.statistic.tiktok_views_count = response.tiktokViewsCount;
        state.statistic.tiktok_likes_count = response.tiktokLikesCount;
        state.statistic.tiktok_followers_count = response.tiktokFollowersCount;
    },

    logoutSuccess: state => {
        state.id = null;
        state.email = "";
        state.name = "";
        state.roles = [];
        state.permissions = [];
    }
};

const actions = {
    login({ commit }, userInfo) {
        const { email, password } = userInfo;
        return new Promise((resolve, reject) => {
            login({ email: email.trim(), password: password })
                .then(response => {
                    commit("dataReceivedSuccess", response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    getUserInfo({ commit }) {
        return new Promise((resolve, reject) => {
            getInfo()
                .then(response => {
                    commit("dataReceivedSuccess", response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    logout({ commit }) {
        return new Promise((resolve, reject) => {
            logout()
                .then(() => {
                    commit("logoutSuccess");
                    removeToken();
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    updateUserPassword(_, data) {
        return updatePassword(data);
    },

    updateUserAvatar({ commit }, data) {
        return new Promise((resolve, reject) => {
            uploadAvatar(data)
                .then(({ data }) => {
                    commit("dataReceivedSuccess", data);
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    loadScoreStatistic({commit}) {
        return new Promise((resolve, reject) => {
            getScoreStatistic().then((data) => {
                commit("statisticReceivedSuccess", data);
                resolve(data);
            })
            .catch(error => {
                reject(error);
            });
        });
    },

    forgotPassword(_, email) {
        return new Promise((resolve, reject) => {
            forgotPassword(email)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    resetPassword(_, {password, password_confirmation, token }) {
        return new Promise((resolve, reject) => {
            resetPassword(password, password_confirmation, token)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
